<template>
  <div v-html="html"></div>
</template>

<script>
  import docendo from '../../docendo'
  export default {
    props: ['school'],
    data () {
      return {
        html: ''
      }
    },
    methods: {
      getAllData () {
        docendo.getSchoolLeftSideMenu(this.school, this.sidebarUpdated)
      },
      sidebarUpdated (data) {
        this.html = data.data
      }
    },
    mounted () {
      this.getAllData()
    }
  }
</script>



// WEBPACK FOOTER //
// SchoolSideMenu.vue?7db64511